import React, { useCallback } from 'react';

/**
 * Checkbox cell for row selection
 * PERFORMANCE: Uses instant DOM manipulation for snappy visual feedback
 */
const CheckboxCell = ({ row }) => {
  const isSelected = row.getIsSelected();
  const taskId = row.original.id;
  
  // Wrap the toggle handler with instant DOM feedback
  const handleChange = useCallback((e) => {
    // Instant DOM feedback: toggle the selected class on the row
    // Use classList.toggle based on the NEW checked state for immediate visual update
    const rowEl = document.querySelector(`.table-view__row[data-row-id="${taskId}"]`);
    if (rowEl) {
      // e.target.checked is the NEW value after the click
      rowEl.classList.toggle('table-view__row--selected', e.target.checked);
    }
    // Call the original handler - this updates TanStack Table's state
    row.getToggleSelectedHandler()(e);
  }, [row, taskId]);
  
  // Handle click on the wrapper for better UX (larger click target)
  const handleClick = useCallback((e) => {
    // Prevent double-firing if clicking directly on the input
    if (e.target.tagName === 'INPUT') return;
    
    // Toggle the checkbox programmatically
    const newChecked = !isSelected;
    const rowEl = document.querySelector(`.table-view__row[data-row-id="${taskId}"]`);
    if (rowEl) {
      rowEl.classList.toggle('table-view__row--selected', newChecked);
    }
    // Toggle the row selection
    row.toggleSelected(newChecked);
  }, [row, taskId, isSelected]);
  
  return (
    <label className="table-view__checkbox-wrapper">
      <input
        type="checkbox"
        className="table-view__checkbox"
        checked={isSelected}
        disabled={!row.getCanSelect()}
        onChange={handleChange}
      />
      <span className={`table-view__checkbox-custom ${isSelected ? 'table-view__checkbox-custom--checked' : ''}`}>
        {isSelected && <span className="table-view__checkbox-tick">✓</span>}
      </span>
    </label>
  );
};

export default CheckboxCell;

